const DealershipLinkSubscriptionType = Object.freeze({
  CalculationSettings: 0,
  QuotingRules: 1,
  Inventory: 2
});

export default DealershipLinkSubscriptionType;


// WEBPACK FOOTER //
// ./src/enums/DealershipLinkSubscriptionType.js